import React, { useEffect, useState } from "react";
import { authService } from "../api/authService";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../contexts/NotificationContext";

export default function SelectTenant() {
  const navigate = useNavigate();
  const { showSuccess, showError } = useNotification();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    setLoading(true);
    setError("");
    authService
      .myTenants()
      .then((list) => {
        const rows = Array.isArray(list?.data) ? list.data : [];
        setTenants(rows);
      })
      .catch((err) => {
        const errMsg = String(err.message || err);
        setError(errMsg);
        showError(errMsg || "Gagal memuat daftar tenant");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const select = (tenant) => {
    try {
      localStorage.setItem("tenantId", tenant.id || "");
      localStorage.setItem("tenantName", tenant.name || "");
      localStorage.setItem("tenantSlug", tenant.slug || "");
      showSuccess(`Berhasil masuk ke ${tenant.name}`);
      console.log("Tenant selected, redirecting to home...", tenant);

      // Use window.location.replace for reliable redirect in both web and Capacitor
      window.location.replace(window.location.origin + "/");
    } catch (error) {
      console.error("Error selecting tenant:", error);
      showError("Gagal memilih tenant");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-teal-50/30 p-6">
      <div className="w-full max-w-lg bg-white ring-1 ring-slate-200/70 rounded-2xl p-6 shadow-xl shadow-slate-900/5">
        <h1 className="text-xl font-bold text-slate-900 mb-2 tracking-tight">
          Pilih Tenant
        </h1>
        <p className="text-sm text-slate-600 mb-6">
          Silakan pilih tenant untuk masuk ke dashboard
        </p>
        {loading && (
          <div className="text-sm text-slate-600">Memuat daftar tenant...</div>
        )}
        {error && (
          <div className="mb-4 px-3 py-2 bg-rose-50 ring-1 ring-rose-200 text-rose-700 rounded-lg text-sm">
            {error}
          </div>
        )}
        {!loading && tenants.length === 0 && (
          <div className="text-sm text-slate-600">
            Belum ada tenant terkait akun Anda
          </div>
        )}
        <div className="space-y-3">
          {tenants.map((t) => (
            <button
              key={t.id}
              onClick={() => select(t)}
              className="w-full flex items-center justify-between px-4 py-3 ring-1 ring-slate-200 rounded-xl hover:ring-teal-400 hover:bg-teal-50/40 transition text-left">
              <div>
                <div className="text-sm font-semibold text-slate-900">
                  {t.name}
                </div>
                <div className="text-xs text-slate-500 mt-0.5">
                  {t.slug} • Paket: {t.subscription_plan || "-"}
                </div>
              </div>
              <div className="text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 bg-teal-50 text-teal-700 ring-1 ring-teal-200 rounded-full">
                {t.status || "ACTIVE"}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
